import {STATE_SELECTOR} from '../constants'

const loadStateSelector = (request) => ({
    type:STATE_SELECTOR.STATE_SELECTOR_LOAD,
    payload : request
});

const loadStateSelectorSuccess = (data) => ({
    type:STATE_SELECTOR.STATE_SELECTOR_SUCCESS,
    payload : data
});


const loadStateSelectorFail = (error) => ({
    type:STATE_SELECTOR.STATE_SELECTOR_FAIL,
    payload : error
});

const loadStateSelectorReset = () => ({
    type:STATE_SELECTOR.STATE_SELECTOR_RESET,
});
export{
    loadStateSelector,
    loadStateSelectorFail,
    loadStateSelectorReset,
    loadStateSelectorSuccess
}

